module.exports = __webpack_public_path__ + "img/user-id-fail.e3bb6db6.svg";